import EditableLine from '../components/shapes/EditableLine';
import Rectangle from '../components/shapes/Rectangle';

// Add a simple generateId if not present
function generateId() {
  return 'id-' + Math.random().toString(36).substr(2, 9);
}

export const createShape = (type, x, y, width, height, options = {}) => {
  const baseShape = {
    id: generateId(),
    type,
    x,
    y,
    width,
    height,
    name: options.name || 'Room',
    showSquareFootage: options.showSquareFootage !== undefined ? options.showSquareFootage : true,
    showInsideDimensions: options.showInsideDimensions !== undefined ? options.showInsideDimensions : false,
    showOutsideDimensions: options.showOutsideDimensions !== undefined ? options.showOutsideDimensions : false,
    flooringPattern: options.flooringPattern || null,
    highlightColor: options.highlightColor || null,
    createdAt: Date.now(),
  };

  switch (type) {
    case 'rectangle':
      return {
        ...baseShape,
        lineData: new Array(8).fill({}),
        lineScaling: new Array(8).fill(0),
        removedLines: [],
        hiddenBySharedLines: [],
      };
    case 'circle':
      return {
        ...baseShape,
        radius: width / 2,
      };
    case 'triangle':
      return {
        ...baseShape,
        points: [
          { x: 0, y: height },
          { x: width / 2, y: 0 },
          { x: width, y: height },
        ],
      };
    case 'line':
      return {
        ...baseShape,
        nodes: [
          { x: 0, y: 0 },
          { x: width, y: height },
        ],
        strokeWidth: options.strokeWidth || 2,
        isCurveMode: options.isCurveMode || false,
        controlPoint: options.controlPoint || null,
      };
    case 'polygonRoom':
      return {
        ...baseShape,
        vertices: options.vertices || [],
        // Optionally, add other room-like properties here
      };
    default:
      return baseShape;
  }
};

export const renderShape = (shape, isSelected, onUpdate, onSelect) => {
  switch (shape.type) {
    case 'rectangle':
      return (
        <Rectangle
          key={shape.id}
          shape={shape}
          isSelected={isSelected}
          onUpdate={onUpdate}
          onSelect={onSelect}
        />
      );
    case 'line':
      return (
        <EditableLine
          key={shape.id}
          shape={shape}
          isSelected={isSelected}
          onUpdate={onUpdate}
          onSelect={onSelect}
        />
      );
    default:
      return null;
  }
}; 